import { AuthAPI } from 'api'
import { all, fork } from 'redux-saga/effects'

import tokenService from 'modules/module-security/tokens/TokenService'
import AuthenticationSaga from './AuthenticationSaga'

export default function* onboardingSagas() {
  yield all([fork(new AuthenticationSaga(AuthAPI, tokenService).supervise)])
}
